<ng-container [formGroup]="formGroup">
  <app-pl-input-wrapper
    [id]="id"
    [label]="label | translate"
    inputType="custom"
    [hint]="hint"
    [hintType]="hintType"
    [formControlName]="'internal'"
    [readonly]="readonly"
    [fieldConfig]="fieldConfig"
  >
    <kendo-multiselect
      #comboboxref
      [data]="(filteredData | async) || []"
      [loading]="isLoading"
      [readonly]="readonly"
      [valueField]="'id'"
      [textField]="'label'"
      [filterable]="true"
      [size]="size"
      [formControlName]="'internal'"
      [allowCustom]="allowCustom"
      [clearButton]="clearButton"
      [valueNormalizer]="valueNormalizer"
      (blur)="onBlur()"
      (open)="onOpen($event)"
    >
      <ng-container *ngIf="showCacheRefreshButton || !pageInfo?.allDataLoaded">
        <ng-template
          *ngIf="pageInfoPosition === 'header'"
          kendoMultiSelectHeaderTemplate
          let-dataItem
        >
          <pl-dropdown-page-info
            *ngIf="pageInfo || showCacheRefreshButton"
            [showCacheRefreshButton]="showCacheRefreshButton"
            [showPageButtons]="showPageButtons"
            [pageInfo]="pageInfo"
            (refreshCache)="refreshCache()"
            (pageInfoChange)="updatePageInfo($event)"
          ></pl-dropdown-page-info>
        </ng-template>
        <ng-template
          *ngIf="pageInfoPosition === 'footer'"
          kendoMultiSelectFooterTemplate
          let-dataItem
        >
          <pl-dropdown-page-info
            *ngIf="pageInfo || showCacheRefreshButton"
            [showCacheRefreshButton]="showCacheRefreshButton"
            [showPageButtons]="showPageButtons"
            [pageInfo]="pageInfo"
            (refreshCache)="refreshCache()"
            (pageInfoChange)="updatePageInfo($event)"
          ></pl-dropdown-page-info>
        </ng-template>
      </ng-container>

      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <div class="content">
          <span
            *ngIf="dataItem.icon"
            class="icon k-icon {{ dataItem.icon }}"
          ></span>
          <div class="title">
            <span>{{ dataItem.label }}</span>
            <div class="subTitle" *ngIf="dataItem.subLabel">
              {{ dataItem.subLabel }}
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template kendoMultiSelectTagTemplate let-dataItem>
        <div [title]="dataItem.subLabel" class="tag-content">
          <a
            *ngIf="fieldConfig?.link && fieldConfig?.linkOptions"
            [title]="fieldConfig.linkOptions?.tooltip ?? 'Open'"
            (click)="openEntity($event, dataItem)"
            target="_top"
            class="link"
          >
            <kendo-icon name="hyperlink-open-sm"></kendo-icon>
          </a>
          <span>{{ dataItem.label }}</span>
        </div>
      </ng-template>
    </kendo-multiselect>
  </app-pl-input-wrapper>
</ng-container>
